import Helpers from '../../helpers/Helpers';
import Constants from '../../constants/Constants';

export const getInstrumentData = (paramDictionary, useCache) => {
  /* minimum expected paramDictionary: 
        ReportName: name of report .json
  */

  if (useCache != undefined && useCache == true) {
    return Helpers.get(`${Constants.CACHED_REPORTS_URL}`, {}, paramDictionary);
  }

  return Helpers.get(`${Constants.REPORTS_URL}`, {}, paramDictionary);
};
